import { render, staticRenderFns } from "./UsersNumber.vue?vue&type=template&id=5c84cab3&scoped=true&"
import script from "./UsersNumber.vue?vue&type=script&lang=js&"
export * from "./UsersNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c84cab3",
  null
  
)

export default component.exports